/* eslint-disable react-hooks/exhaustive-deps */

import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { withStyles } from '@material-ui/core';

import { Box, Button, Grid, Paper, Typography } from '@mui/material';

import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import {
  DELETE_CANDIDATE_TRIP_FAILURE,
  GET_ALL_CANDIDATE_TRIPS_FAILURE,
  GET_CANDIDATE_SERVICES_FAILURE,
  GET_CANDIDATE_TRIP_FAILURE,
  UPDATE_CANDIDATE_SERVICES_FAILURE
} from 'modules/authorizations/store/types/canidateTripTypes';
import {
  deleteCandidateTrip,
  getCandidateServices,
  getCandidateTripById,
  getCandidateTrips,
  postCandidateServices,
  updateCandidateServices
} from 'modules/authorizations/store/actions/canidateTrip.actions';
import { getAuthDateSummary, getAuthorizationSummary, setAuthId, setLoadingComplete } from '../../store/actions/authorizations.actions';
import { getBrokerAgents, getBrokerAgentsById } from 'modules/authorizations/store/actions/dataManagement.actions';

import { showToast } from 'modules/layout/layout.actions';
import CandidateOverviewCard from './candidateOverviewCard.component';
import CandidateTripSummaryCard from './candidateTripSummary.component';
import ServiceTriggeredComment from '../commentsAndNotes/serviceTriggeredComment.component';
import SlidingCommentsAndNotes from '../commentsAndNotes/commentsAndNotesSlidingPanel.component';

import { AUTHORIZATION_MOVE_TYPES, CANDIDATE_SERVICE_STATUSES, SERVICE_IDS, ZERO_GUID } from 'modules/enumerations/enumerationIds';
import SpinnerComponent from 'modules/common/spinner.component';
import { isIdEqual } from 'modules/enumerations/enumerationHelpers';
import { upsertCandidateTrip } from 'modules/authorizations/authorizations.actions';
import { formatTripAddress, formatTripLocation } from 'modules/authorizations/utils';
import { UPSERT_CANDIDATE_TRIP_FAILURE } from 'modules/authorizations/types';
import CreateTripCard from 'modules/common/createAuthTripModal.component';
import StatusMenu from 'modules/common/statusMenu.component';
import { getServiceStatusDates } from '../../store/actions/authorizations.actions';
import { GET_SERVICE_STATUS_DATES_FAILURE } from 'modules/authorizations/store/types/authorizationTypes';
import AuthServiceGlobalEmailCardComponent from 'modules/emailTemplates/authEmailTemplates/authServiceGlobalEmailCard.component';

const styles = theme => ({
  wideControl: {
    minWidth: 174
  },
  section: {
    marginBottom: theme.spacing(2)
  },
  selfServicePolicySelect: {
    minWidth: 300
  },
  card: {
    width: '100%',
    maxWidth: 1500,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  iconRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  dialogIconRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '40px',
    paddingBottom: '20px'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  },
  chip: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  chipClickable: {
    cursor: 'pointer'
  },
  iconOverlayImg: {
    position: 'absolute'
  },
  spacingX: {
    marginRight: theme.spacing(1)
  },
  footer: {
    height: 15,
    marginBottom: theme.spacing(2)
  },
  mb2: {
    marginBottom: '4px',
    marginRight: '16px'
  },
  editModalContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100% !important',
    marginLeft: '0px !important'
  },
  editModalColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '100% !important'
  },
  editModalInput: {
    minWidth: '332px'
  },
  dialogContentContainer: {
    margin: '15px'
  },
  labelText: {
    minWidth: 350,
    marginBottom: 0
  }
});

const isReadOnlyFunc = statusId => {
  return isIdEqual(statusId, CANDIDATE_SERVICE_STATUSES.CANCELED) || isIdEqual(statusId, CANDIDATE_SERVICE_STATUSES.CLOSED);
};

//TODO - Since we can change Move Types, we need to either reset candidate/intern table or display correct status. Upon update it will fix itself.
const calcStatus = (candidateServices, moveTypeId) => {
  const statusId = candidateServices ? candidateServices.statusId : null;
  if (!statusId || statusId === '') return ZERO_GUID;
  if (isIdEqual(moveTypeId, AUTHORIZATION_MOVE_TYPES.INTERSHIP)) {
    return statusId;
  }
  if (isIdEqual(statusId, CANDIDATE_SERVICE_STATUSES.ACTIVE_INTERNSHIP)) {
    const serviceInitiationDate = candidateServices ? candidateServices.serviceInitiationDate : null;
    return serviceInitiationDate ? CANDIDATE_SERVICE_STATUSES.TRIP_COORDINATION : CANDIDATE_SERVICE_STATUSES.INITIATED;
  }
  return statusId;
};

const CandidateServices = props => {
  const { brokerAgents, authId, details, location, enumerations, emailTemplates, vendors, isReadOnlyProp = false } = props;
  const [isLoading, setIsLoading] = useState(false);
  //const vendorsPreferredVendorSorted = CreateVendorRelationshipList(vendors, clientInfo?.clientDetails.clientVendorRelationships);

  const [statuses, setStatuses] = useState(
    details?.serviceStatusDates ? details.serviceStatusDates.filter(s => s.serviceType === 'Candidate/Intern') : []
  );
  const validTemplates = emailTemplates.filter(et => et.serviceId === SERVICE_IDS.CANDIDATE_SERVICE_ID);
  const getStatuses = async () => {
    if (authId) {
      const resp = await props.getServiceStatusDates(authId);
      if (resp && Array.isArray(resp.response)) {
        setStatuses(resp.response.filter(s => s.serviceType === 'Candidate/Intern'));
        return;
      }

      if (Array.isArray(details?.serviceStatusDates)) {
        setStatuses(details.serviceStatusDates.filter(s => s.serviceType === 'Candidate/Intern'));
      }
    }
  };

  useEffect(() => {
    if (authId) {
      getStatuses();
    }
  }, [authId]);

  const candidateServices = details?.candidateServices || {};
  const serviceId = candidateServices?.candidateInternService?.candidateInternServiceId ?? null;
  const [currentStatus, setCurrentStatus] = useState(
    calcStatus(candidateServices.candidateInternService, details?.authorizationDetails?.moveTypeId)
  );

  useEffect(() => {
    setCurrentStatus(calcStatus(candidateServices?.candidateInternService, details?.authorizationDetails?.moveTypeId));
  }, [candidateServices?.candidateInternService, details?.authorizationDetails?.moveTypeId]);

  useEffect(() => {
    if (Array.isArray(details?.serviceStatusDates)) {
      setStatuses(details.serviceStatusDates.filter(s => s.serviceType === 'Candidate/Intern'));
    }
  }, [details?.serviceStatusDates]);

  const candidateStatusTypes =
    enumerations && enumerations?.allEnums && Array.isArray(enumerations?.allEnums?.candidateServiceStatusTypes)
      ? enumerations.allEnums.candidateServiceStatusTypes.filter(s => s.isActive)
      : [{ id: ZERO_GUID, title: '' }];

  const isIntern = isIdEqual(details?.authorizationDetails?.moveTypeId, AUTHORIZATION_MOVE_TYPES.INTERSHIP);

  const [currentTripId, setCurrentTripId] = useState(
    details?.authCanidateTrips?.candidateTrips && details?.authCanidateTrips?.candidateTrips[0]
      ? details?.authCanidateTrips?.candidateTrips[0].tripId
      : null
  );
  const trip = details?.authCanidateTrips?.candidateTrips
    ? details?.authCanidateTrips?.candidateTrips.find(s => s.tripId === currentTripId)
    : null;

  const isReadOnly = isReadOnlyProp || isReadOnlyFunc(currentStatus);

  const authCommentServiceTypes =
    enumerations && enumerations.allEnums && enumerations.allEnums.authCommentService && enumerations.allEnums.authCommentService.length > 0
      ? enumerations.allEnums.authCommentService.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const authCommentRegardingTypes =
    enumerations &&
      enumerations.allEnums &&
      enumerations.allEnums.authCommentRegarding &&
      enumerations.allEnums.authCommentRegarding.length > 0
      ? enumerations.allEnums.authCommentRegarding.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const [showTriggeredComment, setShowTriggeredComment] = useState(false);
  const [showComment, setShowComment] = useState(false);

  const addressOptions =
    details?.addresses && details?.addresses.length > 0
      ? details?.addresses.map(a => {
        const addressLabel = formatTripAddress(a, enumerations?.allEnums?.provinces, enumerations?.allEnums?.countries);
        return { ...a, id: a.addressId, title: addressLabel, description: addressLabel };
      })
      : [];

  useEffect(() => {
    serviceId && props.getCandidateTrips(serviceId);
  }, [serviceId]);

  useEffect(() => {
    getStatuses();
  }, []);

  const handleCancelService = async () => {
    setIsLoading(true);
    let newVals = { ...candidateServices };
    newVals.candidateInternService.authorizationId = authId;
    newVals.candidateInternService.canceledDate = new Date().toISOString();
    newVals.candidateInternService.onHoldDate = null;
    newVals.candidateInternService.serviceCompletionDate = null;
    newVals.candidateInternService.statusId = props.enumerations.allEnums.candidateServiceStatusTypes.find(s => s.title === 'Canceled').id;

    const resp = await props.updateCandidateServices(newVals);
    if (resp.type === UPDATE_CANDIDATE_SERVICES_FAILURE) {
      props.showToast('Failed to update the candidate services info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    } else {
      const getResp = await props.getCandidateServices(authId);
      setCurrentStatus(getResp?.response?.candidateInternService?.statusId ?? currentStatus);
      setIsLoading(false);
      if (getResp.type === GET_CANDIDATE_SERVICES_FAILURE) {
        return false;
      } else {
        const getStatusDatesResp = await props.getServiceStatusDates(authId);
        if (getStatusDatesResp.type === GET_SERVICE_STATUS_DATES_FAILURE) {
          return false;
        } else {
          setStatuses(getStatusDatesResp.response.filter(s => s.serviceType === 'Candidate/Intern'));
          setIsLoading(false);
          return true;
        }
      }
    }
  };

  // const handleCompleteService = async () => {
  //   setCurrentStatus('Completed');
  //   setIsLoading(true);
  //   let newVals = { ...candidateServices };
  //   newVals.candidateInternService.authorizationId = authId;
  //   newVals.candidateInternService.serviceCompletionDate = new Date().toISOString();
  //   newVals.candidateInternService.canceledDate = null;
  //   newVals.candidateInternService.onHoldDate = null;
  //   newVals.candidateInternService.statusId = props.enumerations.allEnums.candidateServiceStatusTypes.find(s => s.title === 'Completed').id;

  //   //setShowTriggeredComment(true);
  //   const resp = await props.updateCandidateServices(newVals);
  //   if (resp.type === UPDATE_CANDIDATE_SERVICES_FAILURE) {
  //     props.showToast('Failed to update the candidate services info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
  //     setIsLoading(false);
  //     return false;
  //   } else {
  //     const getResp = await props.getCandidateServices(authId);
  //     setIsLoading(false);
  //     if (getResp.type === GET_CANDIDATE_SERVICES_FAILURE) {
  //       return false;
  //     } else {
  //       const getStatusDatesResp = await props.getServiceStatusDates(authId);
  //       if (getStatusDatesResp.type === GET_SERVICE_STATUS_DATES_FAILURE) {
  //         return false;
  //       } else {
  //         setStatuses(getStatusDatesResp.response.filter(s => s.serviceType === 'Candidate/Intern'));
  //         setIsLoading(false);
  //         return true;
  //       }
  //     }
  //   }
  //};

  const handleResetStatus = async () => {
    setIsLoading(true);
    let newVals = { ...candidateServices };
    newVals.candidateInternService.authorizationId = authId;
    newVals.candidateInternService.serviceCompletionDate = null;
    newVals.candidateInternService.canceledDate = null;
    newVals.candidateInternService.onHoldDate = null;
    newVals.candidateInternService.serviceInitiationDate = null;
    newVals.candidateInternService.startDate = null;
    newVals.candidateInternService.endDate = null;
    newVals.candidateInternService.statusId = props.enumerations.allEnums.candidateServiceStatusTypes.find(s => s.title === 'Initiated').id;

    const resp = await props.updateCandidateServices(newVals);
    if (resp.type === UPDATE_CANDIDATE_SERVICES_FAILURE) {
      props.showToast('Failed to update the candidate services info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    } else {
      const getResp = await props.getCandidateServices(authId);
      setCurrentStatus(getResp?.response?.candidateInternService?.statusId ?? currentStatus);
      setIsLoading(false);
      if (getResp.type === GET_CANDIDATE_SERVICES_FAILURE) {
        return false;
      } else {
        const getStatusDatesResp = await props.getServiceStatusDates(authId);
        if (getStatusDatesResp.type === GET_SERVICE_STATUS_DATES_FAILURE) {
          return false;
        } else {
          setStatuses(getStatusDatesResp.response.filter(s => s.serviceType === 'Candidate/Intern'));
          setIsLoading(false);
          return true;
        }
      }
    }
  };

  const createTrip = async values => {
    setIsLoading(true);

    let newValues = {};

    newValues.tripName = values.tripName ? values.tripName : '';
    newValues.tripCategoryId = isIntern ? 'B6A894E9-2CCC-4DA6-BD38-9594E9D7AF80' : '9C64495D-3E5D-4D6B-873A-533899EAA7AC';
    newValues.familyAttending = values.familyAttending ? values.familyAttending.join(',') : values.familyAttending;
    newValues.typeOfTrip = values.typeOfTrip ? values.typeOfTrip : '';
    newValues.tripStartDate = values.tripStartDate ? values.tripStartDate : new Date();
    newValues.tripEndDate = values.tripEndDate ? values.tripEndDate : new Date();
    newValues.departureDate = values.departureDate ? values.departureDate : new Date();
    newValues.arrivalDate = values.arrivalDate ? values.arrivalDate : new Date();
    newValues.tripDuration = values.tripDuration ? values.tripDuration : 0;
    newValues.departureAddressId = values.departureAddressId ? values.departureAddressId : 0;
    newValues.destinationAddressId = values.destinationAddressId ? values.destinationAddressId : 0;
    newValues.specialNeeds = values.specialNeeds ? values.specialNeeds : '';
    newValues.notes = values.notes ? values.notes : '';

    if (values.hasBookingDetails && values.hasBookingDetails === 'Self Booked') {
      newValues.hasBookingDetails = false;
    } else {
      newValues.hasBookingDetails = true;
    }

    newValues.airTransport = values.airTransport;
    newValues.airTransportDepartureDate = values.airTransportDepartureDate;
    newValues.airTransportArrivalDate = values.airTransportArrivalDate;
    newValues.airTransportReturnDepartureDate = values.airTransportReturnDepartureDate;
    newValues.airTransportReturnArrivalDate = values.airTransportReturnArrivalDate;

    newValues.hotelBooking = values.hotelBooking;
    newValues.hotelName = values.hotelName;
    newValues.hotelAddressId = values.hotelAddressId;
    newValues.hotelCheckInDate = values.hotelCheckInDate;
    newValues.hotelCheckOutDate = values.hotelCheckOutDate;
    newValues.hotelDurationOfStay = values.hotelDurationOfStay;

    newValues.rentalCarBooking = values.rentalCarBooking;
    newValues.rentalCarClassId = values.rentalCarClassId;
    newValues.otherRentalCar = values.otherRentalCar;
    newValues.rentalCarStartDate = values.rentalCarStartDate;
    newValues.rentalCarEndDate = values.rentalCarEndDate;
    newValues.rentalCarDuration = values.rentalCarDuration;
    newValues.addedBy = values.addedBy ? values.addedBy : 0;
    newValues.addedOn = values.addedOn ? values.addedOn : new Date();
    newValues.modifiedBy = 0;
    newValues.modifiedOn = new Date();

    const resp = await props.upsertCandidateTrip(serviceId, newValues);
    if (resp.type === UPSERT_CANDIDATE_TRIP_FAILURE) {
      props.showToast('Failed to update candidate/intern trips info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    } else {
      await props.getCandidateTrips(serviceId);
      setIsLoading(false);
      return true;
    }
  };

  const deleteTrip = async () => {
    const deleteTripResp = await props.deleteCandidateTrip(currentTripId);
    if (deleteTripResp.type === DELETE_CANDIDATE_TRIP_FAILURE) {
      props.showToast('Failed to delete the current candidate trip info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    } else {
      props.showToast('Trip deleted successfully.', { userMustDismiss: false, severity: 'success' });
      const allTripsResp = await props.getCandidateTrips(serviceId);
      if (allTripsResp.type === GET_ALL_CANDIDATE_TRIPS_FAILURE) {
        props.showToast('Failed to get the candidate trips info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      } else {
        setCurrentTripId(null);
      }
    }
  };

  const getTripData = async () => {
    const tripResp = await props.getCandidateTripById(currentTripId);
    if (tripResp.type === GET_CANDIDATE_TRIP_FAILURE) {
      props.showToast('Failed to get the candidate trip info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    }
  };

  const [openStatusMenu, setOpenStatusMenu] = useState(false);
  const candidateInternStatusOrder = [
    {
      title: 'Initiated',
      id: candidateStatusTypes && candidateStatusTypes.length > 0 ? candidateStatusTypes.find(s => s.title === 'Initiated')?.id : '',
      isActive: true,
      date: candidateServices?.candidateInternService?.serviceInitiationDate ?? candidateServices?.candidateInternService?.addedOn, 
      order: 1
    },
    {
      title: 'Trip Coordination',
      id:
        candidateStatusTypes && candidateStatusTypes.length > 0 ? candidateStatusTypes.find(s => s.title === 'Trip Coordination')?.id : '',
      isActive: true,
      date: candidateServices?.candidateInternService?.serviceInitiationDate,
      order: 2
    },
    {
      title: 'Active Internship',
      id:
        candidateStatusTypes && candidateStatusTypes.length > 0 ? candidateStatusTypes.find(s => s.title === 'Active Internship')?.id : '',
      isActive: true,
      date: candidateServices?.candidateInternService?.startDate,
      order: 3
    },
    {
      title: 'Expense Processing',
      id:
        candidateStatusTypes && candidateStatusTypes.length > 0 ? candidateStatusTypes.find(s => s.title === 'Expense Processing')?.id : '',
      isActive: true,
      date: candidateServices?.candidateInternService?.endDate,
      order: 4
    },
    {
      title: 'Closed',
      id: candidateStatusTypes && candidateStatusTypes.length > 0 ? candidateStatusTypes.find(s => s.title === 'Closed')?.id : '',
      isActive: true,
      date: candidateServices?.candidateInternService?.serviceCompletionDate,
      order: 5
    },
    {
      title: 'Canceled',
      id: candidateStatusTypes && candidateStatusTypes.length > 0 ? candidateStatusTypes.find(s => s.title === 'Canceled')?.id : '',
      isActive: candidateStatusTypes.find(s => isIdEqual(s.id, currentStatus))?.title === 'Canceled' ? true : false,
      date: candidateServices?.candidateInternService?.serviceCanceledDate,
      order: 6
    },
    {
      title: 'On Hold',
      id: candidateStatusTypes && candidateStatusTypes.length > 0 ? candidateStatusTypes.find(s => s.title === 'On Hold')?.id : '',
      isActive: candidateStatusTypes.find(s => isIdEqual(s.id, currentStatus))?.title === 'On Hold' ? true : false,
      date: candidateServices?.candidateInternService?.serviceOnHoldDate,
      order: 7
    },
    {
      title: 'Completed',
      id: candidateStatusTypes && candidateStatusTypes.length > 0 ? candidateStatusTypes.find(s => s.title === 'Completed')?.id : '',
      isActive: candidateStatusTypes.find(s => isIdEqual(s.id, currentStatus))?.title === 'Completed' ? true : false,
      date: candidateServices?.candidateInternService?.ServiceCompletionDate,
      order: 8
    }
  ];

  useEffect(() => {
    if (currentTripId) {
      getTripData();
    }
  }, [currentTripId]);

  const candidateServiceId = candidateServices?.candidateInternService?.candidateInternServiceId ?? null;

  return (
    <Box>
      {showComment && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1200,
            pointerEvents: 'none'
          }}
        />
      )}
      <Box sx={{ padding: '20px' }}>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
          <Paper
            square
            className={classNames('position-fixed', props.classes.headerFixed, props.classes.container)}
            sx={{
              position: 'sticky',
              paddingRight: '10px',
              paddingLeft: '10px',
              marginBottom: '5px',
              minWidth: '100%'
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px', marginBottom: '10px' }}>
              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>
                <div></div>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row', paddingTop: '20px' }}>
                <StatusMenu
                  anchorEl={openStatusMenu}
                  onClose={() => setOpenStatusMenu(false)}
                  currentStatus={candidateStatusTypes.find(s => isIdEqual(s.id, currentStatus))?.title || ''}
                  statusHeader={isIntern ? 'Intern Status' : 'Candidate Status'}
                  statusList={candidateInternStatusOrder}
                  statusDates={statuses}
                  classes={props.classes}
                  serviceInitiatedDate={candidateServices?.candidateInternService?.serviceInitiationDate}
                />
                <Box>
                  <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                      Move Type
                    </Typography>
                  </Box>
                  <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                      {enumerations?.allEnums?.moveTypes.find(m => m.id === details?.authorizationDetails?.moveTypeId).title}
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                      Policy
                    </Typography>
                  </Box>
                  <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                      {details?.authorizationDetails?.relocationPolicyId}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row', paddingTop: '20px' }}>
                {location && !location.pathname.includes('expenses') && (
                  <>
                    <Button
                      color="secondary"
                      variant="contained"
                      sx={{
                        maxHeight: '40px',
                        marginLeft: '12px',
                        marginTop: '8px',
                        backgroundColor: '#f0b11d',
                        '&:hover': { backgroundColor: '#ba8a00' }
                      }}
                      disabled={isLoading}
                      onClick={handleResetStatus}
                    >
                      RESET STATUS
                    </Button>
                    <Button
                      color="secondary"
                      variant="contained"
                      sx={{
                        maxHeight: '40px',
                        marginLeft: '12px',
                        marginTop: '8px',
                        backgroundColor: '#868686',
                        '&:hover': { backgroundColor: '#474747' }
                      }}
                      onClick={handleCancelService}
                      disabled={isLoading}
                    >
                      Cancel Service{' '}
                    </Button>
                    {/* <Button
                      color="secondary"
                      variant="contained"
                      sx={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px' }}
                      onClick={handleCompleteService}
                      disabled={isLoading}
                    >
                      {' '}
                      Complete Service{' '}
                    </Button> */}
                  </>
                )}
                <Button
                  onClick={() => setShowComment(true)}
                  variant="contained"
                  sx={{
                    maxHeight: '40px',
                    marginLeft: '12px',
                    marginTop: '8px',
                    backgroundColor: '#41B7C0',
                    color: 'white',
                    '&:hover': { backgroundColor: '#3d959c' }
                  }}
                  disabled={isLoading}
                >
                  Comments
                </Button>
              </Box>
            </Box>
          </Paper>
        </Grid>
        {isLoading && <SpinnerComponent />}
        {!isLoading && (
          <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid item xs={12} xl={8} rowSpacing={2}>
              <CreateTripCard
                onSubmit={createTrip}
                onDelete={deleteTrip}
                familyMembers={details?.familyMembers}
                trips={details?.authCanidateTrips?.candidateTrips}
                location={location}
                enumerations={props.enumerations.allEnums}
                addresses={addressOptions.filter(s => s.excludeAddressFromSelection === false)}
                showToast={showToast}
                classes={props.classes}
                currentTripId={currentTripId}
                setCurrentTripId={setCurrentTripId}
                formatTripListAddress={address =>
                  formatTripLocation(address, enumerations?.allEnums?.provinces, enumerations?.allEnums?.countries)
                }
                isReadOnly={location.pathname.includes('expenses') || isReadOnly}
                defaultCategory={isIntern ? 'b9b60681-1acd-48a1-8509-8b675c703b4d' : '9c64495d-3e5d-4d6b-873a-533899eaa7ac'}
              />
              {currentTripId && (
                <>
                  <Grid item>
                    <CandidateTripSummaryCard
                      trip={trip}
                      familyMembers={details?.familyMembers}
                      travelRequests={details?.authCanidateTrips?.travelRequests}
                      hideEdit={location.pathname.includes('expenses') || isReadOnly}
                      addresses={addressOptions.filter(s => s.excludeAddressFromSelection === false)}
                      enumerations={props.enumerations}
                      serviceId={candidateServices?.candidateInternService?.candidateInternServiceId}
                    />
                  </Grid>
                </>
              )}
            </Grid>
            <Grid item xs={12} xl={4} rowSpacing={2}>
              <Grid item sx={{ marginBottom: '10px' }}>
                <AuthServiceGlobalEmailCardComponent
                  authId={authId}
                  communication={details.authorizationDetails}
                  serviceTemplates={validTemplates}
                  serviceId={isIntern ? SERVICE_IDS.INTERN_SERVICE_ID : SERVICE_IDS.CANDIDATE_SERVICE_ID}
                  authCommentServicesEnum={authCommentServiceTypes}
                  authCommentRegardingEnum={authCommentRegardingTypes}
                  authSentTemplates={details.sentEmailTemplates}
                  history={props.history}
                  selectedAuthServiceId={candidateServiceId}
                  allVendorOptions={vendors}
                  emailTemplates={emailTemplates}
                  selectedSegmentServiceId={candidateServiceId}
                  isReadOnly={isReadOnly}
                />
                <Box sx={{ display: 'flex', flexDirection: 'row', paddingTop: '16px' }}>
                  <CandidateOverviewCard
                    authId={authId}
                    moveTypeId={details?.authorizationDetails?.moveTypeId}
                    candidateServices={candidateServices}
                    areaTour={details?.authCanidateTrips?.areaTour}
                    brokerAgents={brokerAgents}
                    isReadOnly={location.pathname.includes('expenses') || isReadOnly}
                    enumerations={enumerations}
                    currentStatus={currentStatus}
                    setStatuses={setStatuses}
                    setCurrentStatus={setCurrentStatus}
                  />
                </Box>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Box>
      {showTriggeredComment && (
        <ServiceTriggeredComment
          authorizationId={authId}
          serviceOptionId={'a2ac4e46-bfd3-4656-8f52-e8d0d2aef2dc'}
          displayText={'Candidate - Service Completed Comment'}
          setShowTriggeredComment={setShowTriggeredComment}
          enumerations={enumerations}
        />
      )}
      {showComment && (
        <SlidingCommentsAndNotes
          authorizationId={authId}
          serviceOptionId={'a2ac4e46-bfd3-4656-8f52-e8d0d2aef2dc'}
          setShowComment={setShowComment}
          isOpen={true}
          enumerations={enumerations}
        />
      )}
    </Box>
  );
};

CandidateServices.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {};
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    getAuthorizationSummary,
    getAuthDateSummary,
    getBrokerAgents,
    setAuthId,
    setLoadingComplete,
    getBrokerAgentsById,
    getCandidateServices,
    updateCandidateServices,
    postCandidateServices,
    getCandidateTripById,
    getCandidateTrips,
    deleteCandidateTrip,
    upsertCandidateTrip,
    showToast,
    getServiceStatusDates
  })
)(CandidateServices);
